import { Button } from '@/components/ui/button'
import clsx from 'clsx'
import { ShoppingCart } from 'lucide-react'
import React from 'react'

export function OpenCartButton({
  className,
  quantity,
  ...rest
}: {
  className?: string
  quantity?: number
}) {
  return (
    <button
      className={clsx(
        "p-1.5 sm:p-2.5 hover:bg-white/10 rounded-full transition-all hover:scale-110 duration-200 group relative",
        className
      )}
      {...rest}
    >
      <ShoppingCart className="h-4 w-4 sm:h-5 sm:w-5 text-white group-hover:text-[var(--brand-red)] transition-colors" />

      {quantity ? (
        <span className="absolute -top-1 -right-1 bg-[var(--neon-orange)] text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center shadow-sm">
          {quantity}
        </span>
      ) : null}
    </button>
  )
}
